<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'shopDetailDialog',
})
</script>
<template>
  <ant-Modal v-model:open="state.dialog.visible" transition-name="" :centered="true"
    :wrap-class-name="'wrap-shop-detail-dialog'" :title="state.dialog.title" :width="state.dialog.width"
    :ok-text="state.dialog.submitTxt" :cancel-button-props="{ style: { display: 'none' } }" @ok="closeDialog"
    @cancel="closeDialog" :closable="false" :maskClosable="false">
    <div class="form-content">
      <a-row :gutter="[48, 24]" class="detail-grid">
        <a-col :span="12">
          <div class="detail-item">
            <span class="detail-label">店铺类型：</span>
            <span class="detail-value">{{ detail.storeTypeStr || '-' }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="detail-item">
            <span class="detail-label">场所业态类型：</span>
            <span class="detail-value">{{ detail.venueTypeStr || '-' }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="detail-item">
            <span class="detail-label">店铺名称：</span>
            <span class="detail-value">{{ detail.storeName || '-' }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="detail-item">
            <span class="detail-label">所属行业：</span>
            <span class="detail-value">{{ detail.industryStr || '-' }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="detail-item">
            <span class="detail-label">店铺地址：</span>
            <span class="detail-value">{{ [detail.areaStr, detail.detailAddress].filter(Boolean).join('') || '-'
              }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="detail-item">
            <span class="detail-label">店铺面积：</span>
            <span class="detail-value">{{ detail.buildingArea ? `${detail.buildingArea}㎡` : '-' }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="detail-item">
            <span class="detail-label">联系人：</span>
            <span class="detail-value">{{ detail.contactPerson || '-' }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="detail-item">
            <span class="detail-label">联系手机号：</span>
            <span class="detail-value">{{ detail.contactPhone || '-' }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="detail-item">
            <span class="detail-label">创建时间：</span>
            <span class="detail-value">{{ detail.createTime || '-' }}</span>
          </div>
        </a-col>
      </a-row>
      <div class="space-gap" style="height: 32px" />

      <div class="space-gap" style="height: 22px" />
      <div class="section-title">用户信息</div>
      <div class="space-gap" style="height: 22px" />
      <div class="space-divider" />
      <div class="space-gap" style="height: 19px" />
      <template v-if="detail.users?.length">
        <a-row :gutter="[48, 24]" class="detail-grid">
          <template v-for="(user, index) in detail.users" :key="index">
            <a-col :span="12">
              <div class="detail-item">
                <span class="detail-label">用户昵称：</span>
                <span class="detail-value">{{ user.nickname || user.username || user.fullName || '-' }}</span>
              </div>
            </a-col>
            <a-col :span="12">
              <div class="detail-item">
                <span class="detail-label">手机号：</span>
                <span class="detail-value">{{ user.tel || '-' }}</span>
              </div>
            </a-col>
          </template>
        </a-row>
      </template>
      <div v-else class="empty-users">暂无用户信息</div>
    </div>
  </ant-Modal>
</template>

<script setup lang="ts" name="shopDetailDialog">
import { reactive, ref } from 'vue'

const state = reactive({
  dialog: {
    visible: false,
    title: '店铺信息',
    submitTxt: '关闭',
    width: '900px'
  }
})

const detail = ref<any>({})

const openDialog = (row: any) => {
  detail.value = row || {}
  state.dialog.visible = true
}

const closeDialog = () => {
  state.dialog.visible = false
}

defineExpose({
  openDialog,
  closeDialog
})
</script>

<style scoped lang="less">
.form-content {
  padding: 32px 28px 32px 28px;
}

:global(.wrap-shop-detail-dialog .ant-modal-footer) {
  padding-top: 34px;
}

.space-divider {
  height: 1px;
  background: #A0B8E5;
}

.space-gap {
  height: 16px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  color: #000;
}

.detail-grid {
  .detail-item {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    line-height: 1.5;

    .detail-label {
      flex-shrink: 0;
      width: 110px;
      text-align: right;
      color: rgba(0, 0, 0, 0.65);
    }

    .detail-value {
      flex: 1;
      word-break: break-all;
      color: #000;
    }
  }
}

.empty-users {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  padding-left: 110px;
}
</style>
